var _ellipse, _ellipse2, _g, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListPlr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 76,
    viewBox: "0 0 74 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37,
    cy: 38.0933,
    rx: 37,
    ry: 37.5,
    fill: "#E5ECEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_164_99",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 76
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37,
    cy: 38.0933,
    rx: 37,
    ry: 37.5,
    fill: "#E5ECEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_164_99)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.971,
    y: 20.6824,
    width: 54.029,
    height: 8.27393,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.971,
    y: 7.40845,
    width: 54.029,
    height: 8.27393,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.971,
    y: 47.2302,
    width: 54.029,
    height: 8.27393,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.971,
    y: 60.5042,
    width: 54.029,
    height: 8.27393,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.971,
    y: 33.9563,
    width: 54.029,
    height: 8.27393,
    fill: "#619BBA"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.8973,
    cy: 38.0933,
    r: 2,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListPlr);
export default __webpack_public_path__ + "static/media/list-plr.7cccd24e4b55f4cc975ee62d0f949bdf.svg";
export { ForwardRef as ReactComponent };